import styled from 'styled-components';
import { Avatar, Button } from '@/ui';
import { useCreatorsHub, useFollow, useUserByHandle, followButtonLabel } from '@/hooks';

const Panel = styled.section`
  border: 1px solid ${({ theme }) => theme.color.glassBorder};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.color.glassBg};
  padding: 14px; margin-bottom: 16px;
`;
const Title = styled.h2` margin: 0 0 12px; font-size: ${({ theme }) => theme.fontSize.sm}; color: ${({ theme }) => theme.color.textPrimary}; `;
const Row = styled.div` display: flex; align-items: center; gap: 10px; padding: 6px 0; `;
const Id = styled.div` flex: 1; min-width: 0; display: flex; flex-direction: column; `;
const Name = styled.span` color: ${({ theme }) => theme.color.textPrimary}; font-size: ${({ theme }) => theme.fontSize.sm}; font-weight: 600; `;
const Handle = styled.span` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; `;
const Empty = styled.p` color: ${({ theme }) => theme.color.textMuted}; font-size: ${({ theme }) => theme.fontSize.xs}; margin: 4px 0 0; `;

function FeaturedCreatorRow({ handle }: { handle: string }) {
  const { user } = useUserByHandle(handle);
  const { isFollowing, isRequested, toggleFollow } = useFollow(handle);
  if (!user) return null;
  return (
    <Row>
      <Avatar name={user.name} avatarKey={user.avatarKey} size={36} />
      <Id><Name>{user.name}</Name><Handle>{user.handle}</Handle></Id>
      <Button
        variant={isFollowing || isRequested ? 'secondary' : 'primary'}
        size="sm"
        aria-label={`${followButtonLabel(isFollowing, isRequested)} ${user.handle}`}
        onClick={() => void toggleFollow()}
      >
        {followButtonLabel(isFollowing, isRequested)}
      </Button>
    </Row>
  );
}

export function FeaturedCreatorsPanel() {
  const { featuredCreatorHandles } = useCreatorsHub();
  return (
    <Panel>
      <Title>Featured Creators</Title>
      {featuredCreatorHandles.length === 0 ? (
        <Empty>No featured creators yet.</Empty>
      ) : (
        featuredCreatorHandles.map((h) => <FeaturedCreatorRow key={h} handle={h} />)
      )}
    </Panel>
  );
}
